import React, { useEffect, useState } from "react";
import ViewModal from "@core/modals/ViewModal";
import ViewButton from "@core/buttons/atoms/ViewButton";
import RowDetails from "@hoc/cruds/RowDetails";
import { useTranslation } from "react-i18next";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import FishingTechniqueEUService from "@services/FishingTechniqueEUService";

const ShowFishingTechniqueEU = ({ fishingTechniqueEU }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [fishingTechniqueEUData, setFishingTechniqueEUData] = useState([]);

  const closeModal = () => {
    setShowModal(false);
  };
  useEffect(() => {
    if (showModal)
      FishingTechniqueEUService.find(fishingTechniqueEU.id).then((response) => {
        setFishingTechniqueEUData(response.data.data);
      });
  }, [fishingTechniqueEU.id, showModal]);

  return (
    <PermissionHandler permission={"view_fishing_techniques_eu"}>
      <ViewButton onClick={() => setShowModal(true)} />
      <ViewModal
        show={showModal}
        title={`${t("overview")}`}
        onClose={closeModal}
      >
        <div className="flex flex-col mt-5">
          <RowDetails
            label={t("name")}
            value={
              fishingTechniqueEUData.name
                ? fishingTechniqueEUData.name
                : fishingTechniqueEUData.id
            }
          />
          <RowDetails
            label={t("nameEng")}
            value={fishingTechniqueEUData.name_eng}
          />
          <RowDetails
            label={t("description")}
            value={fishingTechniqueEUData.description}
          />
        </div>
      </ViewModal>
    </PermissionHandler>
  );
};

export default ShowFishingTechniqueEU;
